import { render, staticRenderFns } from "./campaignDetail.vue?vue&type=template&id=a03dbec6&"
import script from "./campaignDetail.vue?vue&type=script&lang=js&"
export * from "./campaignDetail.vue?vue&type=script&lang=js&"
import style0 from "./campaignDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports